import { FileOpener } from '@capawesome-team/capacitor-file-opener';

export const openFile = async (path: string) => {
  await FileOpener.openFile({
    path: path,
  });
};
